const indexItems = [
  { title: '国产剧频道', count: '15,820部', desc: '古装、都市、悬疑、甜宠全类型覆盖', icon: 'ri-china-railway-line' },
  { title: '动作大片', count: '8,450部', desc: '好莱坞巨制、华语动作经典一站收录', icon: 'ri-sword-line' },
  { title: '喜剧合集', count: '6,320部', desc: '开心麻花、周星驰经典，笑到停不下来', icon: 'ri-emotion-happy-line' },
  { title: '韩剧专区', count: '4,980部', desc: '最新热播韩剧、经典高分韩剧全收录', icon: 'ri-heart-pulse-line' },
  { title: '日剧漫改', count: '3,650部', desc: '人气动漫真人化、原创日剧每日更新', icon: 'ri-sun-line' },
  { title: '悬疑烧脑', count: '5,210部', desc: '高能反转、心理惊悚，挑战你的推理能力', icon: 'ri-lightbulb-flash-line' },
  { title: '爱情剧场', count: '7,890部', desc: '甜宠、虐恋、青春校园，满足所有少女心', icon: 'ri-hearts-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">分类索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按类型快速找到你想看的内容，七大核心分类精准导览
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className={`rounded-2xl p-5 md:p-6 border transition-all duration-300 cursor-pointer hover:-translate-y-1 ${
                i === 0
                  ? 'lg:col-span-2 lg:row-span-2 bg-primary-50 border-primary-100'
                  : 'bg-background-50 border-background-200/70 hover:border-accent-200'
              }`}
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 ${
                i === 0 ? 'bg-primary-200' : 'bg-accent-100'
              }`}>
                <i className={`${item.icon} text-lg ${i === 0 ? 'text-primary-700' : 'text-accent-600'}`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 mb-2">{item.count}</p>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}